import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import mangoLogo from '~/assets/mango-gradientLogo_std.png'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const {
  BackgroundColor: TopNavBackgroundColor,
  BorderColor: TopNavBorderColor,
} = themeColorSectionKeys.TopNav.Banner

const TopNavStyleParts = ['banner', 'rightButtons', 'logo'] as const

const helpers = createMultiStyleConfigHelpers(TopNavStyleParts)

export const TopNavStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    banner: {
      backgroundColor: TopNavBackgroundColor,
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 16px',
      display: 'flex',
      borderBottom: '2px solid',
      borderBottomColor: TopNavBorderColor,
    },
    rightButtons: {
      display: 'flex',
      gap: '12px',
      position: 'relative',
    },
    logo: {
      backgroundImage: `url(${mangoLogo})`,
      width: '100px',
      height: '25px',
      marginTop: '8px',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  },
})

export const useTopNavStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof TopNavStyleParts>(
    getName({ TopNavStyle }),
    props,
  )
}
